import type { Pixel } from "@pdfking/renderer-api"

import type { ImageArray } from "../../types/ImageArray"

export const ImportImage = (blob: Blob): Promise<ImageArray> =>
  new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      const canvas = document.createElement("canvas")
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext("2d")!
      ctx.drawImage(img, 0, 0)
      const imageData = ctx.getImageData(0, 0, img.width, img.height)
      resolve({
        width: img.width as Pixel,
        height: img.height as Pixel,
        data: new Uint8Array(imageData.data.buffer),
      })
    }
    img.onerror = reject
    img.src = URL.createObjectURL(blob)
  })
